import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, filter, tap } from "rxjs/operators";
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {  Router } from '@angular/router';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
    static notification: NzNotificationService;
    static router: Router;
    constructor(
        private notification: NzNotificationService,

        private router: Router) 
        {
        ApiErrorInterceptor.notification = notification;
        ApiErrorInterceptor.router = router;
    }

    handleError(error: HttpErrorResponse) {
        if (error.status == 401) {
            localStorage.removeItem('token')
            ApiErrorInterceptor.notification.error("Error", "Session Expired");
            ApiErrorInterceptor.router.navigateByUrl("/login");

        } else   if (error.status == 400) {

            ApiErrorInterceptor.notification.error("Error", error?.error); 
        }
      //   ApiErrorInterceptor.notification.error("Error", error?.error?.errorMessage ?? "Please try again later.");
        return throwError(error);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(filter(response => response instanceof HttpResponse))
            .pipe(tap((response) => {
                if (response instanceof HttpResponse) {
                    const responseBody = response.body;
                    // const { success, errorMessage } = responseBody;
                    // if (success != null && !success) {
                    //     if (errorMessage != null && errorMessage != "") {
                            // alert("throwerror");
                            // ApiErrorInterceptor.notification.error("Error", errorMessage);
                        // }
                    // }
                }
            }),
                catchError(this.handleError)
            );
    }
}